module.exports = __webpack_public_path__ + "static/media/logo.13a9a4c4.svg";